export type {TopCardItem, TopCardValueType} from './TopCard.types';
export * from './utils.types';

export type Day = {
    weeklyDailyIndex: number;
    fullDate: Date;
    dayNumber: number;
    dayName: string;
    monthName: string;
    dayShortName: string;
    monthNumber: number;
    workedHours: number;
    workedDays: string;
    hasWorked: boolean;
    workedHoursDetails: string;
    workedDaysDetails: string;
};
export type Days = Array<Day>;

export type Week = {daysOfWeek: Days; weekRangeText: string};

export enum TemporalUnit {
    HOURLY = 'HOUR',
    DAILY = 'DAY',
}

export enum Weekend {
    SATURDAY = 5,
    SUNDAY = 6,
}
export * from './expense-batch.types';
